export default __webpack_public_path__ + "static/media/contato-emergencia.06553a20.png";